<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.delay;
const seconds = computed(() => props.data.seconds ?? 2);
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>Espera {{ seconds }} segundo(s) antes de continuar.</p>
    <Handle type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
